import axios from 'axios';

import Config from '../config/config';

const { backendUrl } = Config;

const loginUser = (data) => axios.post(`${backendUrl}/api/usermanagement/login`, data);
const activateUser = (data) => axios.post(`${backendUrl}/api/usermanagement/activateuser`, data);
const unsubscribeNewsletter = (data) => axios.post(`${backendUrl}/api/usermanagement/unsubscribenewsletter`, data);
const registerUser = (data) => axios.post(`${backendUrl}/api/usermanagement/registeruser`, data);
const oauthLogin = (data) => axios.post(`${backendUrl}/api/usermanagement/oauthlogin`, data);
const modifyPassword = (data) => axios.post(`${backendUrl}/api/usermanagement/modifypassword`, data);
const resetPassword = (data) => axios.post(`${backendUrl}/api/usermanagement/resetpassword`, data);
const getLoyaltyPoints = (data) => axios.post(`${backendUrl}/api/usermanagement/getloyaltypoints`, data);
const generateCoupons = (data) => axios.post(`${backendUrl}/api/usermanagement/generatecoupons`, data);

const getNewsletterSubscribers = (params) => {
  const config = {
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('userAccessToken')}`
    },
    params: {
      page: params.page,
      itemsPerPage: params.itemsPerPage,
      sortBy: params.sortBy,
      sortDesc: params.sortDesc
    }
  };
  return axios.get(`${backendUrl}/api/usermanagement/newsletter-subscribers`, config);
};

const exportNewsletterSubscribers = () => {
  const config = {
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('userAccessToken')}`
    },
    responseType: 'blob'
  };
  return axios.get(`${backendUrl}/api/usermanagement/export-newsletter-subscribers`, config);
};

const modifyUser = (data,userAccessToken) => {
  // Retrieve the userAccessToken from the Vuex store
  // Set up the Axios request with the Authorization header
  const config = {
    headers: {
      'Authorization': `Bearer ${userAccessToken}`
    }
  };

  // Send the POST request with the data and configuration
  return axios.post(`${backendUrl}/api/usermanagement/modifyuser`, data, config)
    .then(response => {
      return response.data; // Return the response data if needed
    })
    .catch(error => {
      console.error('Error making request:', error);
      throw error; // Throw the error to be handled by the caller if needed
    });
};

const makeRequestWithToken = (userAccessToken)  => {
  // Set up the configuration for the Axios request
  const config = {
    headers: {
      'Authorization': `Bearer ${userAccessToken}` // Set the Authorization header
    }
  };

  // Make the Axios GET request to the desired URL
  return axios.get(`${backendUrl}/api/usermanagement/renewusertoken`, config)
    .then(response => {
      // Handle successful response
      return response;
    })
    .catch(error => {
      // Handle error
      console.error('Error making request:', error);
    });
};

export default {
  loginUser,
  registerUser,
  oauthLogin,
  modifyPassword,
  resetPassword,
  modifyUser,
  activateUser,
  makeRequestWithToken,
  getLoyaltyPoints,
  generateCoupons,
  unsubscribeNewsletter,
  getNewsletterSubscribers,
  exportNewsletterSubscribers
};
